import { render } from "./App.vue?vue&type=template&id=743711f1"
const script = {}

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__